<template>
  <div v-reveal class="section-title">
    <div class="section-title__eyebrow">{{ $pick(eyebrow) }}</div>
    <h2>{{ $pick(title) }}</h2>
    <p v-if="description">{{ $pick(description) }}</p>
  </div>
</template>

<script>
export default {
  name: "SectionTitle",
  props: {
    eyebrow: {
      type: String,
      default: "SECTION"
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ""
    }
  }
};
</script>
